import { render, staticRenderFns } from "./index.vue?vue&type=template&id=62bfbd1c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bfbd1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62bfbd1c')) {
      api.createRecord('62bfbd1c', component.options)
    } else {
      api.reload('62bfbd1c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=62bfbd1c&scoped=true", function () {
      api.rerender('62bfbd1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hotel/label/index.vue"
export default component.exports